import { UserPersonalDataProps } from '../types'

export const getTrustedThirdData = ({
  t,
  isEditing,
  name,
  surname,
  phone,
  email,
}: UserPersonalDataProps) => [
  { name: 'name', label: t('common:name'), value: name },
  { name: 'surname', label: t('common:surname'), value: surname },
  {
    name: 'phone',
    label: t('common:phone'),
    value: phone,
    isEditing,
  },
  {
    name: 'email',
    label: t('common:email'),
    value: email,
    isEditing,
  },
]
